module.exports = __webpack_public_path__ + "img/expand.2e3cab49.svg";